import * as Sentry from '@sentry/react'
import { useEffect } from 'react'
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom'

// import.meta.env.MODE is set to 'e2e' when serving for end-to-end testing purposes -AF 3/20/23
if (import.meta.env.PROD && import.meta.env.MODE !== 'e2e') {
  Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    integrations: [
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes
      }),
      Sentry.replayIntegration()
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    // We recommend adjusting this value in production
    tracesSampleRate: 0.1,

    // Never capture a replay just because a session happened. The replay
    // integration stays in buffering mode and only sends when an error occurs.
    replaysSessionSampleRate: 0,

    // Every session that hits an error gets its buffered replay sent.
    replaysOnErrorSampleRate: 1.0,

    environment: import.meta.env.PROD
      ? import.meta.env.VITE_INFRA_ENVIRONMENT
      : 'development',
    release: import.meta.env.VITE_RELEASE_SHA,
  })
}
